export default "__VITE_ASSET__CE331fKA__"